import { YupClient } from "./YupClient";
import { YupAdmin } from "./YupAdmin";
import { YupLogin } from "./YupLogin";
import { YupClinic, YupUpdateClinic } from "./YupClinic";
import { YupCoupon } from "./YupCoupon";
import { YupDoctor } from "./YupDoctor";
import { YupGenerateCoupon } from "./YupGenreateCoupon";
import { YupGenerateCdicCoupon } from "./YupGenerateCdicCoupon";
import { YupOtp } from "./YupOtp";
import { YupPassword } from "./YupPassword";
import { YupPhone } from "./YupPhone";
import { YupRedeem } from "./YupRedeem";
import { YupContraception } from "./YupContraception";
import { YupOne } from "./YupOne";
import { YupTwo } from "./YupTwo";
import { YupProduct } from "./YupProduct";
import { YupInventory } from "./YupInventory";
import { YupOrder } from "./YupOrder";
import { YupCdicClient } from "./YupCdicClient";
import { YupProgram } from "./YupProgram";
import { YupService } from "./YupService";
export const useYup = () => {
  return {
    YupClient: YupClient(),
    YupLogin: YupLogin(),
    YupAdmin: YupAdmin(),
    YupCdicClient: YupCdicClient(),
    YupClinic: YupClinic(),
    YupUpdateClinic: YupUpdateClinic(),
    YupCoupon: YupCoupon(),
    YupDoctor: YupDoctor(),
    YupGenerateCoupon: YupGenerateCoupon(),
    YupGenerateCdicCoupon: YupGenerateCdicCoupon(),
    YupOtp: YupOtp(),
    YupPassword: YupPassword(),
    YupPhone: YupPhone(),
    YupRedeem: YupRedeem(),
    YupContraception: YupContraception(),
    YupOne: YupOne(),
    YupTwo: YupTwo(),
    YupProduct: YupProduct(),
    YupInventory: YupInventory(),
    YupOrder: YupOrder(),
    YupProgram: YupProgram(),
    YupService: YupService(),
  };
};
